import { GetLocale } from '@cuatroochenta/co-admin-react-library';

const BASE_URL = () => process.env.REACT_APP_URL + GetLocale() + '/api/';
const BASE_URL_PRIVATE = () => BASE_URL() + 'private/';
export default class Urls {

    public static get URL_IMPORT_USERS() {
        return `${BASE_URL_PRIVATE()}user/wsimport`;
    }

    public static get URL_GET_NEWS() {
        return `${BASE_URL_PRIVATE()}news`;
    }

    public static get URL_GET_IMAGES() {
        return `${BASE_URL()}images`;
    }

    public static get URL_GET_VIDEOS() {
        return `${BASE_URL()}videos`;
    }

    public static get URL_GET_THUMBNAILS() {
        return `${BASE_URL()}thumbnails`;
    }

    public static get URL_GIVE_LIKE() {
        return `${BASE_URL_PRIVATE()}news/like`;
    }

    public static get URL_GET_USER() {
        return `${BASE_URL_PRIVATE()}user`;
    }

    public static get URL_DELETE_MEDIA_FROM_NEWS() {
        return `${BASE_URL_PRIVATE()}news/media`;
    }

    public static get URL_GET_MENU() {
        return `${BASE_URL_PRIVATE()}menu`;
    }

    public static get URL_UPDATE_MENU() {
        return `${BASE_URL_PRIVATE()}menu`;
    }

    public static get URL_GET_CENTERS() {
        return `${BASE_URL_PRIVATE()}center`;
    }

    public static get URL_GET_CONVERSATIONS() {
        return `${BASE_URL_PRIVATE()}conversation`;
    }

    public static get URL_GET_MESSAGING_GROUP() {
        return `${BASE_URL_PRIVATE()}messaging-group`;
    }

    public static get URL_SYNC_USERS() {
        return `${BASE_URL_PRIVATE()}sync`;
    }

    public static get URL_SYNC_DOCUMENTS() {
        return `${BASE_URL_PRIVATE()}document/sync`
    }

    public static get URL_GET_ALBUMS() {
        return `${BASE_URL_PRIVATE()}album`;
    }

    public static get URL_DELETE_MEDIA_FROM_ALBUM() {
        return `${BASE_URL_PRIVATE()}album/media`
    }

    public static get URL_GET_EVENTS() {
        return `${BASE_URL_PRIVATE()}event`
    }

    public static get URL_GET_PRIVATE_SOCIAL_DOCUMENTS() {
        return `${BASE_URL_PRIVATE()}social-document`
    }

    public static get URL_GET_PUBLIC_SOCIAL_DOCUMENTS() {
        return `${BASE_URL()}social-document`
    }

    public static get URL_GET_SHARE_OPTIONS() {
        return `${BASE_URL_PRIVATE()}share-option`
    }

    public static get URL_GET_STATISTICS() {
        return `${BASE_URL_PRIVATE()}statistics`
    }

    public static get URL_GET_AUDIT() {
        return `${BASE_URL_PRIVATE()}user/audit`
    }
}